interface BuzunarLogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}

export function BuzunarLogo({ 
  className = '', 
  variant = 'full' 
}: BuzunarLogoProps) {
  // Beauty Copper logo approved by user
  return (
    <svg 
      width="128" 
      height="128" 
      viewBox="0 0 128 128" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={variant === 'full' ? 'Buzunarul Logo' : 'Buzunarul Icon'}
    >
      {/* Beauty Copper gradient */}
      <defs>
        <linearGradient id="beautyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#D0917F', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#B87968', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Main shape with beauty copper */}
      <path d="M 24 40 L 104 40 L 104 88 L 80 112 L 48 112 L 24 88 Z" fill="url(#beautyGrad)"/>
      
      {/* Cut-out creating container shape */}
      <path d="M 40 50 L 88 50 L 88 85 L 72 100 L 56 100 L 40 85 Z" fill="#FFFFFF"/>
      
      {/* Inner accent elements */}
      <rect x="50" y="60" width="28" height="4" rx="2" fill="#E6B0A0" opacity="0.4"/>
      <rect x="50" y="70" width="20" height="4" rx="2" fill="#E6B0A0" opacity="0.3"/>
      <rect x="50" y="80" width="24" height="4" rx="2" fill="#E6B0A0" opacity="0.2"/>
    </svg>
  );
}